<div class="timeline">
    <div class="timeline-line"></div>
    <div
        class="timeline-item"
        *ngFor="let item of timelineItems; let i = index; let last = last; let first = first"
        matTooltip="{{ item.tooltipText }}">
        <div class="timeline-item-marker">
            <div *ngIf="!withIcons" class="timeline-item-marker-number">
                {{ timelineItemsDescOrder ? timelineItems.length - i : i + 1 }}
            </div>
            <img *ngIf="withIcons && item.iconPath" [src]="item.iconPath" class="timeline-item-marker-icon" />
        </div>
        <div
            class="timeline-item-text"
            [ngClass]="{
                'timeline-item-text-last': last,
                'timeline-item-text-first': first,
            }">
            <div class="timeline-item-text-primary">{{ item.text }}</div>
            <div *ngIf="item.secondaryText" class="timeline-item-text-secondary">
                {{ item.secondaryText }}
            </div>
        </div>
    </div>
</div>
